export function filterMenuItems(items, isFinancialRegulation) {
  return items
    .filter((item) => {
      if (!item.requiresComplianceMode) {
        return true;
      }

      return item.requiresComplianceMode === 'financial_regulation' ? isFinancialRegulation : true;
    })
    .map((item) => {
      if (!Array.isArray(item.children)) {
        return item;
      }

      return {
        ...item,
        children: filterMenuItems(item.children, isFinancialRegulation),
      };
    })
    .filter((item) => !Array.isArray(item.children) || item.children.length > 0);
}

export function resolveFinancialRouteAccess({ isLoading, isFinancialRegulation }) {
  if (isLoading) {
    return 'loading';
  }

  if (!isFinancialRegulation) {
    return 'redirect';
  }

  return 'allow';
}
